import { Navigate, Outlet, useLocation } from 'react-router'
import { Loader2 } from 'lucide-react'
import { useTenantAuth } from '@/auth/TenantAuthContext'

/**
 * Guards dashboard routes: spinner while the session restores, then the child
 * routes for a signed-in tenant user, or `/login` (keeping the attempted path).
 */
export function TenantProtectedRoute() {
  const { isAuthenticated, isLoading } = useTenantAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-svh items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    )
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}
